import styled from '@emotion/styled';
import { Button, Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { peach } from 'constants/blogColors';
import { SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta } from 'graphql/__generated__/operations/SingleArticleQuery';
import { useRouter } from 'next/router';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { Headline } from './CTACommonStyles';

type props = {
  inArticleCTA: SingleArticleQuery_articleCollection_items_body_links_entries_block_InArticleCtaContainer_fallbackCta;
};
export const DemoCTA = ({ inArticleCTA }: props) => {
  const { headline, buttonText, buttonUrl, image } = inArticleCTA;
  const trackEvent = useTrackEvent();
  const router = useRouter();

  return (
    <CTAWrapper>
      <Image src={image?.url!} alt="zapier steps" />
      <ActionSection>
        <Headline>{headline}</Headline>
        <ButtonWrapper>
          <Button
            target="_blank"
            href={buttonUrl!}
            color="black"
            onClick={() => {
              trackEvent('call_to_action', {
                path: window.location.pathname,
                from_path: document.referrer,
                cta_name: 'watch_zapier_in_action',
                cta_raw_text: headline!,
                cta_location: router.asPath,
                cta_goal: 'get_more_information',
                link_destination: buttonUrl!,
              });
            }}
          >
            {buttonText}
          </Button>
        </ButtonWrapper>
      </ActionSection>
    </CTAWrapper>
  );
};

const CTAWrapper = styled.article`
  border-radius: 5px;
  background-color: ${peach};
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ActionSection = styled.section`
  padding: 30px 20px;
  ${mediaQueries.tablet} {
    padding: 45px;
  }
  flex: 1;
  text-align: center;
`;

const Image = styled.img`
  flex: 1;
  width: 100%;
  position: relative;
  margin-left: 40px;
  margin-top: -30px;

  ${mediaQueries.tablet} {
    margin-left: 54px;
    margin-top: -65px;
  }
  ${mediaQueries.desktop} {
    margin-left: 64px;
    margin-top: -90px;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
  ${mediaQueries.tablet} {
    margin-top: 25px;
  }

  /**
   * We had to resort to this as we're already overriding the span:hover behavior
   here https://github.com/zapier/blog/blob/f21ad3a031a3f701201b03449ed0f39d0087a89b/src/components/Link/Link.tsx#L75-L78
   */
  a:hover,
  a:focus {
    span {
      color: ${Colors.white};
    }
  }
`;
